import React from 'react'
import EditText from 'blocks.simple/editText/editText'
import { cn } from 'ethcss'
import { grid, item } from '../../theme'
import translate from 'core/translate'
import type { EditTextInputElement } from 'blocks.simple/editText/editText.types'
import { EditableTextDefaultProps, EditableTextProps, EditableTextState, EditableTextValue } from './editableText.types'

class EditableText<Value extends EditableTextValue = string> extends React.Component<
    EditableTextProps<Value>,
    EditableTextState
> {
    static defaultProps: EditableTextDefaultProps
    inputFocus: EditTextInputElement | null = null
    updating: boolean = false
    state: EditableTextState

    constructor(p_: EditableTextProps<Value>) {
        super(p_)

        this.updating = false
        this.state = {
            text: p_.text ?? '',
            focused: !p_.id,
        }
        this.onBlur = this.onBlur.bind(this)
        this.save = this.save.bind(this)
    }
    componentDidUpdate(prevProps: EditableTextProps<Value>) {
        if (!this.updating && this.props.text !== prevProps.text) {
            this.setState({ text: this.props.text ?? '' })
        }

        if (this.props.ignoreUpdating && this.props.text !== prevProps.text) {
            this.setState({ text: this.props.text ?? '' })
        }
    }
    onBlur() {
        this.setState({ focused: false })
        this.save()
    }
    save() {
        const s_ = this.state
        const p_ = this.props

        if (!p_.validate(s_.text as Value)) {
            if (!p_.id) {
                p_.onSaveEmpty()
                if (p_.revertEmptyValue) {
                    this.setState({ text: p_.text ?? '' })
                }
            } else {
                this.setState({ text: p_.text ?? '' })
            }
        } else {
            if (!p_.id) {
                p_.onCreate(s_.text as Value)
            } else {
                this.updating = true
                p_.onUpdate(s_.text as Value, () => {
                    this.updating = false
                    if (this.inputFocus) {
                        this.inputFocus.blur()
                    }
                })
            }
        }
    }
    render() {
        const s_ = this.state
        const p_ = this.props

        return (
            <form
                onSubmit={(e) => {
                    e.preventDefault()
                    this.save()
                }}
                className={cn(grid.w100, p_.containerClassName)}
            >
                <EditText
                    type={p_.type}
                    label={p_.label}
                    inputRef={(input) => {
                        this.inputFocus = input
                    }}
                    className={cn({ [item.pointer]: !s_.focused }, p_.className)}
                    icon={p_.id && !p_.disabled && !p_.hideIcon ? 'pencil' : undefined}
                    iconColor={p_.iconColor || 'grey'}
                    iconSize={'14'}
                    value={s_.text}
                    mod={p_.mod}
                    onChange={(text: EditableTextValue) => {
                        this.setState({ text })
                        if (p_.onChange && !p_.id) {
                            p_.onChange(text as Value)
                        }
                    }}
                    defaultFocus={!p_.id && !p_.disableDefaultFocus}
                    onIconClick={(_event, input) => input?.focus()}
                    onBlur={this.onBlur}
                    onFocus={() => this.setState({ focused: true })}
                    placeholder={p_.placeholder || translate('emptyLabelNameError')}
                    showIconOnHover={true}
                    disabled={p_.disabled}
                    onEndTyping={p_.onEndTyping}
                    indentSize={p_.indentSize}
                    rounded={p_.rounded}
                />
            </form>
        )
    }
}

EditableText.defaultProps = {
    onCreate: () => {},
    onUpdate: () => {},
    onEndTyping: () => {},
    onSaveEmpty: () => {},
    mod: 'text',
    hideIcon: false,
    validate: (text) => !!text,
}

export default EditableText
